export function concatArray<T>(a: T[], b: T[]): T[] {
    return [...(a ?? []), ...(b ?? [])];
}

export function isNotNil<T>(val: T | null | undefined): val is T {
    return val !== null && val !== undefined;
}
